import { supabase } from '@/lib/supabase/supabaseClient';
import { UseCrmProjectConnectionsProps } from '.';
export const getCrmProjectConnections = async ({crmProjectId}: UseCrmProjectConnectionsProps) => await supabase.from('project').select(`*`).eq('crm_project_id', crmProjectId!)